export default __webpack_public_path__ + "static/media/business_card_reduced.5aa0fc8c.jpg";